// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__K8Lgg","tab":"styles_tab__xBNVQ","icon":"styles_icon__PYTrX","activeTab":"styles_activeTab__Ho8i1","activeBackground":"styles_activeBackground__rI8vn"};